module.exports = __webpack_public_path__ + "img/united-kingdom.f56a8195.png";